module.exports = __webpack_public_path__ + "img/2.1a475057.png";